import { siteCall } from "../../src/utils/WebCall";
import urls from '../../src/utils/urls'
import { languageOptions } from '../../src/config/Constants'


export const updateUser = async(id, params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.user_url + "/update",
        method: "PUT",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const partialUpdateUser = async(id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_url + "/partial-update",
      method: "PATCH",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getUser = async(id, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_url + "/profile",
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getCurrentUser = () => {
  // let uid = localStorage.getItem("@auth");
  let user_id = localStorage.getItem("uid") || null;
  let idToken = localStorage.getItem("idToken") || null;
  let refreshToken = localStorage.getItem("refreshToken") || null;
  let result = {
    uid: user_id,
    idToken: idToken,
    refreshToken: refreshToken
  }
  // console.log("getCurrentUser:", result)
  return result
}


export const NewUserModel = (props) => {
  const meetTimeChecker = props?.meetTimeChecker || {
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
  const subscription = props?.subscription || {
    free: {
      languages: ["english"],
      recordLimit: 3,
      timeLimit: 120,
    },
  };

  const custom_vocabulary = props?.custom_vocabulary || {};
  // Initialize customVocabulary with empty arrays for each language
  Object.keys(languageOptions).forEach((language) => {
    custom_vocabulary[language] = [];
  });

  return {
    meetTimeChecker: meetTimeChecker,
    subscription: subscription,
    custom_vocabulary: custom_vocabulary,
  }
}


export const fetchUserData = async (dispatch) => {
  let user = getCurrentUser();
  return getUser(user.uid,
      (response) => {
        const data = response.data;
        import("../redux/actions/authActions").then((actions) =>
          dispatch(actions.addUser(data))
        );
        return data;
      },
      (error) => {
          console.log("fetchUserData ERROR: ", error);
          return Promise.reject(error);
      }
  )
};


export const getUserLanguages = (userData, languageOptions) => {
  let subscription = userData?.subscription || {};
  let userLanguages = {};
  Object.entries(subscription).map(([subscription_package, package_values]) => {
    let languages = package_values?.languages;  
    Object.entries(languageOptions).map(([key, value]) => {
      if(languages.indexOf(key) != -1){
        userLanguages[key] = value;
      }
    })
  })
  return userLanguages;
}